module.exports = __webpack_public_path__ + "static/media/breath-times.6889cc4f.png";